module.exports = require('./src/');



// WEBPACK FOOTER //
// ./_rc-notification-3.0.0/index.js